module.exports = __webpack_public_path__ + "static/media/redParrot.51b7ce91.png";